import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts';
import { fetchListaNfse } from '../api/ListaNfseApi';
import type { FiltrosListaNfse, ListaNfseResponse } from '../types';

export function useListaNfse(
  filtros?: FiltrosListaNfse,
  options?: Omit<UseQueryOptions<ListaNfseResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  const query = useQuery<ListaNfseResponse, Error>({
    queryKey: ['servicos-nfse', cnpjGestor, filtros],
    queryFn: () => fetchListaNfse(filtros),
    staleTime: 5 * 60 * 1000,
    ...options,
    enabled: (options?.enabled ?? true) && !!cnpjGestor,
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar NFS-e',
      description: 'Não foi possível carregar a listagem de NFS-e. Tente novamente.',
    });
  }, [query.error, toast]);

  return query;
}
